import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NotificationService, DataService, LoaderService, ErrorService, EVENTO, TYPEMESSAGE, UtilityService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { MatChipInputEvent } from '@angular/material';
import { Idocumento } from './../shared/documento.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DocumentoService {
  constructor(private dataService: DataService, private errorService: ErrorService, private notificationService: NotificationService,
    private loaderService: LoaderService, private utilityService: UtilityService, private sessionInfo: SessionInfo) { }

  private insertarDocumentoUrl: string = 'documento/insertar';
  private actualizarDocumentoUrl: string = 'documento/Actualizar';
  private obtenerDocumentoUrl: string = 'documento/Obtener';
  private listarDocumentoUrl: string = 'documento/Listar';
  private listarPorDocumentoUrl: string = 'documento/ListarPor';

  listarDocumento(pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    this.dataService.set(this.listarDocumentoUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarPorDocumento(userID: number, filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pUserID", String(userID));
    this.dataService.set(this.listarPorDocumentoUrl);
    return this.dataService.execGetJson(parameters);
  }

  obtenerDocumento(codigo: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(codigo));
    this.dataService.set(this.obtenerDocumentoUrl);
    return this.dataService.execGetJson(parameters);;
  }

  insertarDocumento(documento: Idocumento): any {
    let parameters: string;
    parameters = JSON.stringify({
      propietarioID: documento.propietarioID,
      descripcion: documento.descripcion,
      FotoRuta: documento.FotoRuta,
      status: documento.status,
      userCreation: this.sessionInfo.getCodUsuario(),
      claseArchivo: documento.claseArchivo
    });

    this.dataService.set(this.insertarDocumentoUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarDocumento(documento: Idocumento): any {

    let parameters: string;
    parameters = JSON.stringify({
      documentoID: documento.documentoID,
      propietarioID: documento.propietarioID,
      descripcion: documento.descripcion,
      FotoRuta: documento.FotoRuta,
      status: documento.status,
      userLastUpdate: this.sessionInfo.getCodUsuario(),
      claseArchivo: documento.claseArchivo
    });
    this.dataService.set(this.actualizarDocumentoUrl);
    return this.dataService.execPostJson(parameters);
  }
}


